export default __webpack_public_path__ + "static/media/Level=4.1c00759b.svg";